import { toastManager } from "@salestrak/ui";

import { copyToClipboard } from "#app/lib/utils/copy-to-clipboard";

export async function copyText(text: string, what: string) {
  const ok = await copyToClipboard(text);
  if (ok) toastManager.add({ title: `${what} copied`, type: "success" });
  else
    toastManager.add({
      title: `Failed to copy ${what.toLowerCase()}`,
      type: "error",
    });
}

export function openHref(href: string) {
  if (typeof window !== "undefined") window.open(href, "_blank");
}
